import { Options } from 'highcharts';
import { merge } from 'lodash';
import moment from 'moment-timezone';
import { commonOptions, legendItemClick } from './highcharts-common-options';

const darkThemeOptions = (): Options => {
  const primaryColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-color-primary');
  const secondColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-color-warning');
  const thirdColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-color-success');
  const fourthColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-color-danger');

  const timezoneAbbr = moment
    .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
    .format('z');

  return {
    colors: [
      primaryColor,
      secondColor,
      thirdColor,
      fourthColor,
      '#aaeeee',
      '#ff0066',
      '#eeaaee',
      '#55BF3B',
      '#DF5353',
      '#7798BF',
      '#aaeeee',
    ],
    chart: {
      backgroundColor: 'transparent',
    },
    xAxis: {
      gridLineColor: '#707073',
      labels: {
        style: {
          color: '#E0E0E3',
        },
      },
      lineColor: '#707073',
      minorGridLineColor: '#505053',
      tickColor: '#707073',
      title: {
        style: {
          color: '#A0A0A3',
        },
      },
    },
    yAxis: {
      gridLineColor: '#707073',
      labels: {
        style: {
          color: '#E0E0E3',
        },
      },
      lineColor: '#707073',
      minorGridLineColor: '#505053',
      tickColor: '#707073',
      tickWidth: 1,
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      style: {
        color: '#F0F0F0',
      },
      dateTimeLabelFormats: {
        day: `%b %e, ${timezoneAbbr}`,
        hour: `%b %e — %l:%M%P, ${timezoneAbbr}`,
      },
      borderWidth: 0,
      shared: true,
    },
    plotOptions: {
      series: {
        events: {
          legendItemClick,
        },
        dataLabels: {
          color: '#F0F0F3',
          style: {
            fontSize: '13px',
          },
        },
        borderWidth: 0,
        borderColor: 'transparent',
        marker: {
          lineColor: '#333',
        },
        stacking: 'normal',
      },
      boxplot: {
        fillColor: '#505053',
      },
      column: {
        borderRadius: 1,
        pointPadding: -0.1,
        borderWidth: 0.5,
        crisp: false,
      },
      errorbar: {
        color: 'white',
      },
    },
    legend: {
      itemStyle: {
        color: '#E0E0E3',
      },
      itemHoverStyle: {
        color: '#FFF',
      },
      itemHiddenStyle: {
        color: '#606063',
      },
      title: {
        style: {
          color: '#C0C0C0',
        },
      },
    },
    credits: {
      enabled: false,
    },
    drilldown: {
      activeAxisLabelStyle: {
        color: '#F0F0F3',
      },
      activeDataLabelStyle: {
        color: '#F0F0F3',
      },
    },
    navigation: {
      buttonOptions: {
        theme: {
          fill: '#505053',
          stroke: '#DDDDDD',
        },
      },
    },
    // scroll charts
    rangeSelector: {
      buttonTheme: {
        fill: '#505053',
        stroke: '#000000',
        style: {
          color: '#CCC',
        },
        states: {
          hover: {
            fill: '#707073',
            stroke: '#000000',
            style: {
              color: 'white',
            },
          },
          select: {
            fill: '#000003',
            stroke: '#000000',
            style: {
              color: 'white',
            },
          },
        },
      },
      inputBoxBorderColor: '#505053',
      inputStyle: {
        backgroundColor: '#333',
        color: 'silver',
      },
      labelStyle: {
        color: 'silver',
      },
    },
    navigator: {
      handles: {
        backgroundColor: '#666',
        borderColor: '#AAA',
      },
      outlineColor: '#CCC',
      maskFill: 'rgba(255,255,255,0.1)',
      series: {
        color: '#7798BF',
        lineColor: '#A6C7ED',
      },
      xAxis: {
        gridLineColor: '#505053',
      },
    },
    scrollbar: {
      barBackgroundColor: '#808083',
      barBorderColor: '#808083',
      buttonArrowColor: '#CCC',
      buttonBackgroundColor: '#606063',
      buttonBorderColor: '#606063',
      rifleColor: '#FFF',
      trackBackgroundColor: '#404043',
      trackBorderColor: '#404043',
    },
  };
};

const highChartsDarkTheme = (): Options =>
  merge({}, commonOptions(), darkThemeOptions());

export { highChartsDarkTheme };
